module.exports = __webpack_public_path__ + "static/media/Lens-Natural Shine.d40961d7.png";